import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homePageData } from '../data/pageData';
import GradientBackground from '../components/GradientBackground';
import SectionTitle from '../components/SectionTitle';
import PhilosophySection from '../components/PhilosophySection';
import TrustedClients from '../components/TrustedClients';

const HomePage = () => {
    const navigate = useNavigate();
    const data = homePageData;
    return (
        <div className="bg-white text-gray-800 ">
            <section
                className="min-h-screen flex flex-col justify-between items-center text-center px-0 relative overflow-hidden"
                style={{
                    backgroundImage: `url('${data.hero.backgroundImage}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                {/* Dark overlay with gradient */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#1f2937]/95 via-[#1f2937]/90 to-[#1f2937]/80"></div>

                {/* Main content */}
                <div className="relative z-10 container mx-auto pt-32 pb-16 animate-fadeInUp">
                    <h1 className="text-6xl sm:text-4xl md:text-7xl font-extrabold mb-6 leading-tight tracking-tight text-white">
                        {data.hero.titleLine1}<br className="hidden md:inline" /> <span className="text-yellow-500">{data.hero.titleLine2}</span>
                    </h1>
                    <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto">
                        {data.hero.subtitle}
                    </p>
                    <button
                        onClick={() => navigate(data.hero.mainButtonLink)}
                        className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-10 py-4 rounded-lg text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                    >
                        {data.hero.mainButtonText}
                    </button>
                </div>


                {/* Technology Partners Section */}
                <div className="relative z-10 w-full pb-4">
                    <div className="container mx-auto">
                        <div className="flex flex-col items-center gap-2">
                            {/* <h2 className="text-xl font-bold text-yellow-500">Technology Partners</h2>
                             */}
                            <SectionTitle
                                subtitle={"Technology Partners"}
                                theme="dark"
                                className='mb-0 flex'
                            />
                            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
                                {data.partners.map(partner => (
                                    <img
                                        key={partner.id}
                                        src={partner.src}
                                        alt={partner.alt}
                                        title={partner.alt}
                                        className="h-12 rounded grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Scroll indicator */}
                <div className="bottom-40 left-1/2 transform -translate-x-1/2 animate-bounce opacity-70">
                    <svg className="w-8 h-8 text-yellow-500" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M19 9l-7 7-7-7"></path>
                    </svg>
                </div>
            </section>

            {/* Trusted Clients - Horizontal Scroll */}
            <TrustedClients theme="light" variant="scroll" showStats={false} compact={true} />

            {/* <GradientBackground 
                className="py-4"                
                fromColor="#754400"
                viaColor="#eab308"
                toColor="#754400"
                direction="br"
            > 
            <section className="py-4 bg-gradient-to-br from-yellow-50 to-yellow-100">
                
                <div className="container mx-auto px-4 ">
                    <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                        <div className="text-left">
                            <h2 className="text-xl font-bold text-yellow-600">Technology Partners</h2>
                        </div>
                        <div className="flex flex-wrap items-center gap-8 md:gap-6">
                            {data.partners.map(partner => (
                                <img 
                                    key={partner.id}
                                    src={partner.src}
                                    alt={partner.alt} 
                                    className="h-8 grayscale hover:grayscale-0 transition-all duration-300"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            {/* </GradientBackground> */}

            <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-16">
                        <div className="md:w-1/2 animate-slideInLeft group">
                            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                                <img
                                    src={data.solutionsSection.imageSrc}
                                    alt="Jiotronik Solutions"
                                    className="w-full transform transition-all duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </div>
                        <div className="md:w-1/2 animate-slideInRight">
                            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-yellow-600">
                                {data.solutionsSection.title}
                            </h2>
                            <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                                {data.solutionsSection.description}
                            </p>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                {data.solutionsSection.points.map(point => (
                                    <div
                                        key={point.title}
                                        className="group bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-yellow-500/30"
                                    >
                                        <div className="flex items-center space-x-4">
                                            <div className="bg-yellow-500/10 p-3 rounded-lg group-hover:bg-yellow-500/20 transition-colors duration-300">
                                                <span className="text-yellow-500 text-2xl">{point.icon}</span>
                                            </div>
                                            <div>
                                                <h4 className="font-semibold text-lg text-gray-800 group-hover:text-yellow-600 transition-colors duration-300">
                                                    {point.title}
                                                </h4>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    We understand and evaluate the client's requirements to satisfy committed deadline.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <button
                                onClick={() => navigate(data.solutionsSection.ctaButtonLink)}
                                className="mt-8 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-bold px-8 py-3 rounded-lg text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 hover:from-yellow-600 hover:to-yellow-700"
                            >
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <GradientBackground
                className="py-12 relative overflow-hidden"
                fromColor="#111827"
                viaColor="#1F2937"
                toColor="#030712"
                direction="br"
            >
                {/* Decorative elements 
                <div className="absolute top-0 left-0 w-full h-auto overflow-">
                    <div className="absolute -top-24 -left-24 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl"></div>
                </div>*/}

                <div className="container mx-auto px-4 relative">
                    <SectionTitle
                        subtitle={"Enterprise Solutions"}
                        title={data.valueToCustomer.title}
                        description={data.valueToCustomer.subtitle}
                        theme="dark"
                    />

                    <div className="relative">
                        {/* Main content container with perspective */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 perspective-1000 auto-rows-fr">
                            {data.valueToCustomer.values.map((item, index) => (
                                <div
                                    key={item.title}
                                    className="group relative"
                                    style={{
                                        transform: `translateZ(${index * 20}px)`,
                                        transition: 'all 0.5s ease-out'
                                    }}
                                >
                                    {/* Background shape */}
                                    <div className="absolute inset-0 bg-gradient-to-br from-gray-800/80 to-gray-900/80 rounded-2xl transform rotate-3 group-hover:rotate-0 transition-transform duration-500"></div>

                                    {/* Content container */}
                                    <div className="relative bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 group-hover:border-yellow-500/30 transition-all duration-500 h-full flex flex-col">
                                        {/* Icon container with dynamic background */}
                                        <div className="relative mb-6">
                                            <div className="absolute -inset-4 bg-gray-500/10 rounded-full blur-xl group-hover:bg-yellow-600/20 transition-all duration-500"></div>
                                            <div className="relative flex items-center justify-center w-16 h-16 mx-auto">
                                                <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-transparent rounded-xl transform rotate-3 transition-transform duration-500 group-hover:rotate-0"></div>
                                                <span className="relative text-yellow-500 text-4xl">{item.icon}</span>
                                            </div>
                                        </div>

                                        <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-yellow-500 transition-colors duration-300">
                                            {item.title}
                                        </h3>
                                        <p className="text-gray-300 leading-relaxed">
                                            {item.desc}
                                        </p>

                                        {/* Hover effect line */}
                                        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500/0 via-yellow-500 to-yellow-500/0 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA Button with enhanced styling */}
                        <div className="text-center mt-16">
                            <button
                                onClick={() => navigate(data.valueToCustomer.ctaButtonLink)}
                                className="relative group bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-12 py-5 rounded-xl text-lg overflow-hidden transition-all duration-300 transform hover:scale-105"
                            >
                                <span className="relative z-10">{data.valueToCustomer.ctaButtonText}</span>
                                <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <div className="absolute -inset-1 bg-yellow-500/20 rounded-xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </GradientBackground>

            <section className="py-20 relative">
                {/* Subtle background pattern */}
                <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] opacity-50"></div>

                <div className="container mx-auto px-4 relative">
                    <SectionTitle
                        title={data.bestServices.title}
                        subtitle="Enterprise Solutions"
                        theme="light"
                    />

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {data.bestServices.services.map((service, index) => (
                            <div
                                key={service.title}
                                className="group relative h-full"
                            >
                                <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent rounded-xl transition-all duration-500 group-hover:from-yellow-500/10"></div>

                                <div className="relative bg-white p-8 rounded-xl border border-gray-100 hover:border-yellow-200 transition-all duration-500 h-full flex flex-col">
                                    {/* Icon with background effect */}
                                    <div className="relative mb-8">
                                        <div className="absolute -inset-4 bg-yellow-500/5 rounded-full blur-xl group-hover:bg-yellow-500/10 transition-all duration-500"></div>
                                        <div className="relative flex items-center justify-center w-16 h-16 mx-auto">
                                            <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-transparent rounded-xl transform rotate-3 transition-transform duration-500 group-hover:rotate-0"></div>
                                            <span className="relative text-yellow-500 text-3xl">{service.icon}</span>
                                        </div>
                                    </div>

                                    <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center group-hover:text-yellow-600 transition-colors duration-300">
                                        {service.title}
                                    </h3>
                                    <p className="text-gray-600 leading-relaxed mb-6 text-center flex-grow">
                                        {service.desc}
                                    </p>

                                    <div className="flex justify-center mt-auto">
                                        <button
                                            onClick={() => navigate(data.bestServices.ctaButtonLink)}
                                            className="inline-flex items-center px-4 py-2 text-sm font-medium text-yellow-600 bg-yellow-50 rounded-lg hover:bg-yellow-100 transition-all duration-300"
                                        >
                                            <span>Explore Service</span>
                                            <svg className="w-4 h-4 ml-2 transform transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-16">
                        <div className="inline-flex items-center space-x-4">
                            <button
                                onClick={() => navigate(data.bestServices.ctaButtonLink)}
                                className="px-8 py-4 bg-yellow-500 text-white font-semibold rounded-lg shadow-sm hover:bg-yellow-600 transition-all duration-300 transform hover:scale-105"
                            >
                                {data.bestServices.ctaButtonText}
                            </button>
                            <button
                                onClick={() => navigate(data.bestServices.ctaButtonLink2)}
                                className="px-8 py-4 text-gray-700 font-semibold rounded-lg border border-gray-200 hover:border-yellow-200 hover:text-yellow-600 transition-all duration-300"
                            >
                                Contact Sales
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-12 bg-gray-700 text-black text-center">
                <div className="container mx-auto px-4 animate-pulseSlow">
                    <SectionTitle
                        title={data.emergencyServices.title}
                        subtitle={data.emergencyServices.subtitle}
                        theme="dark"
                        className="mb-8"

                    />
                    <button
                        onClick={() => navigate(data.emergencyServices.ctaButtonLink)}
                        className="bg-yellow-500 hover:bg-yellow-600 text-gray-600 font-bold px-10 py-4 rounded-lg text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                    >
                        {data.emergencyServices.ctaButtonText}
                    </button>
                </div>
            </section>

            <PhilosophySection data={data.philosophy} />
        </div>
    );
};

export default HomePage;